import Lottie from 'lottie-react';

import dog14Treat from '../jsons/Dog_14_Treat.json';

const Dog14Treat = props => {
  return <Lottie animationData={dog14Treat} {...props} />;
};

export default Dog14Treat;
